























































































































































































































import Vue from 'vue';
import ShipStock from '@/classes/fleet/shipStock';
import ShipMaster from '@/classes/fleet/shipMaster';
import ShipStockDiff from '../../classes/fleet/shipStockDiff';
import SiteSetting from '../../classes/siteSetting';
import Const from '../../classes/const';

type logText = {
  type: number;
  title: string;
  current: string;
  old: string;
  diff: number;
  slot?: number;
};

type tableRow = {
  type: number;
  ship: ShipMaster;
  level: number;
  logs: logText[];
};

export default Vue.extend({
  name: 'ShipImportDiff',
  props: {
    handleClose: {
      type: Function,
    },
  },
  data: () => ({
    diffs: [] as tableRow[],
    noDiff: false,
    showExpMode: false,
    showNewcomers: true,
    showDiffs: true,
    showExpulsions: true,
    totalDiffExp: 0,
    isMobile: true,
  }),
  mounted() {
    this.generateTable();
  },
  watch: {},
  computed: {
    isNotJapanese(): boolean {
      return this.$i18n.locale !== 'ja';
    },
    needTrans(): boolean {
      const setting = this.$store.state.siteSetting as SiteSetting;
      return this.$i18n.locale !== 'ja' && !setting.nameIsNotTranslate;
    },
    newcomersCount(): number {
      return this.diffs.filter((v) => v.type === 1).length;
    },
    diffCount(): number {
      return this.diffs.filter((v) => v.type === 2).length;
    },
    expulsionCount(): number {
      return this.diffs.filter((v) => v.type === 3).length;
    },
  },
  methods: {
    getShipName(ship: ShipMaster) {
      if (this.needTrans) {
        const shipName = ShipMaster.getSuffix(ship);
        const trans = (v: string) => (v ? `${this.$t(v)}` : '');
        return shipName.map((v) => trans(v)).join('');
      }
      return ship.name || '';
    },
    hasReachedLevelHalfway(targetLevel: number, currentExp: number, oldExp: number): boolean {
      const targetLevelBorder = Const.LEVEL_BORDERS.find((v) => v.lv === targetLevel);
      if (!targetLevelBorder) return false;

      const halfwayExp = Math.floor(targetLevelBorder.req / 2);
      return currentExp >= halfwayExp && oldExp < halfwayExp;
    },
    hasReachedLevelRangeHalfway(fromLevel: number, toLevel: number, currentExp: number, oldExp: number): boolean {
      const fromLevelBorder = Const.LEVEL_BORDERS.find((v) => v.lv === fromLevel);
      const toLevelBorder = Const.LEVEL_BORDERS.find((v) => v.lv === toLevel);
      if (!fromLevelBorder || !toLevelBorder) return false;

      const halfwayExp = fromLevelBorder.req + Math.floor((toLevelBorder.req - fromLevelBorder.req) / 2);
      return currentExp >= halfwayExp && oldExp < halfwayExp;
    },
    generateTable() {
      this.isMobile = window.innerWidth < 600;
      const all = this.$store.state.ships as ShipMaster[];
      const currentStock = this.$store.state.shipStock as ShipStock[];
      const diff = this.$store.state.shipStockDiff as ShipStockDiff;

      this.diffs = [];
      this.totalDiffExp = 0;

      // 着任行
      if (this.showNewcomers) {
        for (let i = 0; i < diff.newcomers.length; i += 1) {
          const newcomer = diff.newcomers[i];
          const master = all.find((v) => v.id === newcomer.id);
          if (!master || (this.showExpMode && !newcomer.exp)) continue;

          const logs = [];
          if (this.showExpMode) {
            logs.push({
              type: 0,
              title: 'exp',
              current: newcomer.exp.toLocaleString(),
              old: '0',
              diff: newcomer.exp,
            });

            this.totalDiffExp += newcomer.exp;
          } else if (newcomer.releaseExpand) {
            logs.push({
              type: 2,
              title: '補強増設',
              current: '',
              old: '',
              diff: 0,
            });
          }
          this.diffs.push({
            type: 1,
            ship: master,
            level: newcomer.level,
            logs,
          });
        }
      }

      if (this.showDiffs) {
        for (let i = 0; i < diff.diffs.length; i += 1) {
          const old = diff.diffs[i];
          const current = currentStock.find((v) => v.uniqueId === old.uniqueId);
          if (current) {
            const master = all.find((v) => v.id === current.id);
            if (!master) continue;

            const logs: logText[] = [];
            // 経験値モード
            if (this.showExpMode) {
              const diffExp = current.exp - old.exp;
              if (current.exp !== old.exp) {
                logs.push({
                  type: 0,
                  title: 'exp',
                  current: current.exp.toLocaleString(),
                  old: old.exp.toLocaleString(),
                  diff: diffExp,
                });
              }
              this.totalDiffExp += diffExp;
            } else {
              if (current.level !== old.level) {
                logs.push({
                  type: 9,
                  title: 'Lv',
                  current: current.level.toLocaleString(),
                  old: old.level.toLocaleString(),
                  diff: current.level - old.level,
                });
              }
              if (current.level >= 100 && old.level <= 99) {
                logs.push({
                  type: 10,
                  title: 'ケッコン',
                  current: '',
                  old: '',
                  diff: 0,
                });
              }
              if (current.level === Const.MAX_LEVEL && old.level < Const.MAX_LEVEL) {
                logs.push({
                  type: 11,
                  title: '最大Lv',
                  current: '',
                  old: '',
                  diff: 0,
                });
              }
              if (current.level < 99 && this.hasReachedLevelHalfway(99, current.exp, old.exp)) {
                logs.push({
                  type: 12,
                  title: 'Lv99折り返し',
                  current: '',
                  old: '',
                  diff: 0,
                });
              }
              if (current.level < Const.MAX_LEVEL && this.hasReachedLevelRangeHalfway(Const.PREVIOUS_MAX_LEVEL, Const.MAX_LEVEL, current.exp, old.exp)) {
                logs.push({
                  type: 13,
                  title: 'カンスト拡張折り返し',
                  current: Const.MAX_LEVEL.toLocaleString(),
                  old: Const.PREVIOUS_MAX_LEVEL.toLocaleString(),
                  diff: 0,
                });
              }
              if (current.improvement.luck !== old.improvement.luck) {
                logs.push({
                  type: 4,
                  title: `${this.$t('Database.運改修')}`,
                  current: (master.luck + current.improvement.luck).toLocaleString(),
                  old: (master.luck + old.improvement.luck).toLocaleString(),
                  diff: current.improvement.luck - old.improvement.luck,
                });
              }
              if (current.improvement.hp !== old.improvement.hp) {
                const baseHP = current.level <= 99 ? master.hp : master.hp2;
                logs.push({
                  type: 5,
                  title: `${this.$t('Database.耐久改修')}`,
                  current: (baseHP + current.improvement.hp).toLocaleString(),
                  old: (baseHP + old.improvement.hp).toLocaleString(),
                  diff: current.improvement.hp - old.improvement.hp,
                });
              }
              if (current.improvement.asw !== old.improvement.asw) {
                logs.push({
                  type: 6,
                  title: `${this.$t('Database.対潜改修')}`,
                  current: current.improvement.asw.toLocaleString(),
                  old: old.improvement.asw.toLocaleString(),
                  diff: current.improvement.asw - old.improvement.asw,
                });
              }
              if (current.id !== old.id) {
                const oldMaster = all.find((v) => v.id === old.id);
                logs.push({
                  type: 1,
                  title: '改造',
                  current: this.getShipName(master),
                  old: this.getShipName(oldMaster || new ShipMaster()),
                  diff: 0,
                });
              }
              if (current.releaseExpand && !old.releaseExpand) {
                logs.push({
                  type: 2,
                  title: '補強増設',
                  current: '',
                  old: '',
                  diff: 0,
                });
              }
              const currentSlots = current.slots?.length ? current.slots : master.slots;
              const oldSlots = old.slots?.length ? old.slots : master.slots;
              for (let slotIndex = 0; slotIndex < currentSlots.length; slotIndex += 1) {
                const currentSlot = currentSlots[slotIndex] ?? 0;
                const oldSlot = oldSlots[slotIndex] ?? 0;
                const slotDiff = currentSlot - oldSlot;
                if (slotDiff <= 0) continue;

                logs.push({
                  type: 7,
                  title: '搭載数拡張',
                  current: currentSlot.toLocaleString(),
                  old: oldSlot.toLocaleString(),
                  diff: slotDiff,
                  slot: slotIndex + 1,
                });
              }
            }

            if (!logs.length) continue;

            this.diffs.push({
              type: 2,
              ship: master,
              level: current.level,
              logs,
            });
          }
        }
      }

      // 除籍行
      if (this.showExpulsions) {
        for (let i = 0; i < diff.expulsionShips.length; i += 1) {
          const expulsionShip = diff.expulsionShips[i];
          const master = all.find((v) => v.id === expulsionShip.id);
          if (!master || (this.showExpMode && !expulsionShip.exp)) continue;

          const logs = [];
          if (this.showExpMode) {
            logs.push({
              type: 0,
              title: 'exp',
              current: '0',
              old: expulsionShip.exp.toLocaleString(),
              diff: -expulsionShip.exp,
            });
            this.totalDiffExp -= expulsionShip.exp;
          }

          this.diffs.push({
            type: 3,
            ship: master,
            level: expulsionShip.level,
            logs,
          });
        }
      }

      // 条件なしだけどテーブルログがない！
      if (this.showNewcomers && this.showExpulsions && this.showDiffs && !this.diffs.length && !this.showExpMode) {
        // EXPモードでもう一度作成
        this.showExpMode = true;
        this.noDiff = true;
        this.generateTable();
        return;
      }

      if (this.showExpMode) {
        // 経験値差分順
        // ひとえに経験値差分順番
        this.diffs.sort((a, b) => +a.logs[0].diff - +b.logs[0].diff);
      } else {
        // いい感じのソート
        this.diffs.sort((a, b) => {
          if (a.type !== b.type) {
            return a.type - b.type;
          }

          // ログ個数順
          const aLogCount = a.logs.length;
          const bLogCount = b.logs.length;
          if (aLogCount !== bLogCount) {
            return aLogCount - bLogCount;
          }

          if (aLogCount && bLogCount && a.logs[0].type !== b.logs[0].type) {
            return a.logs[0].type - b.logs[0].type;
          }

          return a.level - b.level;
        });
      }
    },
    addMinusString(value: number): string {
      return (value > 0 ? '+ ' : '') + value.toLocaleString();
    },
  },
});
